import type { HTMLAttributes, ReactNode } from "react";

export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  live?: boolean;
  dotColor?: string;
  children?: ReactNode;
}

export function Chip({
  live = false,
  dotColor,
  className,
  children,
  ...rest
}: ChipProps) {
  const cls = ["vb-chip", className].filter(Boolean).join(" ");
  return (
    <span className={cls} {...rest}>
      {live ? (
        <span
          className="dot"
          style={
            dotColor ? { background: dotColor, boxShadow: `0 0 8px ${dotColor}` } : undefined
          }
        />
      ) : null}
      {children}
    </span>
  );
}
